



















import { trackEvent } from './../../../../utils/index';
import { defineComponent, PropType, toRefs } from '@vue/composition-api';
import { TypeItem } from '../types';

const name = 'ttam-promotion-type';

export default defineComponent({
  name,
  props: {
    list: {
      type: Array as PropType<TypeItem[]>,
      default: () => [],
    },
    value: {
      type: Number,
      default: -1,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { value } = toRefs(props);
    const onClick = (val: TypeItem) => {
      if (!props.disabled && !val.disabled) {
        if (val.clickEventKey) {
          trackEvent(val.clickEventKey);
        }
        emit('input', val.value?.[0]);
        emit('change-item', val);
      }
    };

    const isActive = (item: TypeItem) => item.value.includes(value.value);

    return {
      name,
      onClick,
      isActive,
    };
  },
});
